import script from "./ChatButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatButton.vue?vue&type=script&setup=true&lang=js"

import "./ChatButton.vue?vue&type=style&index=0&id=a73763cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a73763cc"]])

export default __exports__